import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faFacebookF } from "@fortawesome/free-brands-svg-icons";

import { faPencil, faPhone } from "@fortawesome/free-solid-svg-icons";

import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";

import api from "../../utils/axiosPublic";

const NavbarHome = () => {
  const sidenavToggle = () => {
    const navbarSupportedContent = document.getElementById(
      "navbarSupportedContent"
    );

    let testClass = navbarSupportedContent.className;

    if (
      testClass === "navbar-collapse collapse show" &&
      window.innerWidth < 992
    ) {
      navbarSupportedContent.classList.remove("show");
    }
  };

  useEffect(() => {
    getTopics();
  }, []);

  const [topics, setTopics] = useState([]);

  const getTopics = async () => {
    await api
      .get(`/getTopics`)
      .then((res) => {
        if (res.data.errCode === 0) {
          setTopics(res.data.topics);
        }
      })
      .catch(() => {});
  };

  const topicItem = () => {
    if (topics.length > 0) {
      return topics

        ?.filter((e) => e.slug !== "chinh-sach")

        .map((item, i) => {
          return (
            <NavDropdown.Item
              key={`topicItem${i}`}
              as={Link}
              to={`/chu-de/${item.slug}`}
              onClick={sidenavToggle}
            >
              {item.nameVi}
            </NavDropdown.Item>
          );
        });
    }
  };

  return (
    <header id="header" className="top-head">
      <div className="hotline">
        <div className="text-white hotline-content">
          <FontAwesomeIcon icon={faPhone} /> Liên hệ:&nbsp;
          <a href="tel: 0889881010">0889.88.1010</a>
          &nbsp;-&nbsp;
          <a href="tel: 0847881010">0847.88.1010</a>
          &nbsp;-&nbsp;
          <a href="tel: 0847881010">0849.88.1010</a>
        </div>

        <div className="icon_">
          <ul className="list-inline socials">
            <li className="list-inline-item px-1">
              <Link to={"https://www.facebook.com/kateccantho"} target="_blank">
                <FontAwesomeIcon icon={faFacebookF} />
              </Link>
            </li>

            <li className="list-inline-item px-1">
              <Link
                to={"https://zalo.me/0849881010"}
                className="fw-bold"
                target="_blank"
              >
                Zalo
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <Navbar collapseOnSelect expand="md" bg="light" variant="light">
        <Container fluid>
          <Link className="navbar-brand" to={"/"}>
            <img
              src="../../assets/user/images/logo-kafood.svg"
              alt="katec_logo"
            />
          </Link>

          <a
            className="button-85 px-3 text-navy transform-scale-1-1"
            href="/dang-ky-dung-thu"
          >
            <FontAwesomeIcon icon={faPencil} /> Đăng ký dùng thử
          </a>

          <pre> </pre>

          <Navbar.Toggle aria-controls="navbarSupportedContent" />

          <Navbar.Collapse id="navbarSupportedContent">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to={"/"} onClick={sidenavToggle}>
                Trang chủ
              </Nav.Link>

              <Nav.Link as={Link} to={"/gioi-thieu"} onClick={sidenavToggle}>
                Giới thiệu
              </Nav.Link>

              <Nav.Link
                as={Link}
                to={"/tinh-nang-phan-mem-quan-ly-suat-an-kafood"}
                onClick={sidenavToggle}
              >
                Tính năng
              </Nav.Link>

              <Nav.Link as={Link} to={"/bang-gia"} onClick={sidenavToggle}>
                Bảng giá
              </Nav.Link>

              <Nav.Link as={Link} to={"/dang-ky-goi"} onClick={sidenavToggle}>
                Đăng ký gói phần mềm
              </Nav.Link>

              <NavDropdown title="Góc chia sẻ" id="collasible-nav-dropdown">
                <NavDropdown.Item
                  as={Link}
                  to={"/goc-chia-se"}
                  onClick={sidenavToggle}
                >
                  Tất cả
                </NavDropdown.Item>

                {topicItem()}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default NavbarHome;
